import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { dateIt } from "@/lib/format";
import { Card, CardContent } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  useEffect(() => { api.get("/activity-logs").then(r => setLogs(r.data)); }, []);
  return (
    <div className="space-y-6" data-testid="admin-logs">
      <div>
        <h1 className="font-display text-3xl font-extrabold text-slate-900">Log attività</h1>
        <p className="text-slate-500 mt-1">Tracciato operazioni utenti · ultimi 200 eventi.</p>
      </div>
      <Card className="border-slate-200"><CardContent className="p-0">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Data</TableHead><TableHead>Utente</TableHead><TableHead>Ruolo</TableHead>
            <TableHead>Azione</TableHead><TableHead>Entità</TableHead><TableHead>Dettaglio</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {logs.map((l) => (
              <TableRow key={l.id} data-testid={`log-row-${l.id}`}>
                <TableCell className="text-xs">{dateIt(l.created_at)}</TableCell>
                <TableCell>{l.user_email}</TableCell>
                <TableCell><Badge variant="outline" className="capitalize">{l.role}</Badge></TableCell>
                <TableCell className="capitalize font-medium">{l.action}</TableCell>
                <TableCell>{l.entity}</TableCell>
                <TableCell className="text-xs text-slate-500">{JSON.stringify(l.meta || {})}</TableCell>
              </TableRow>
            ))}
            {logs.length === 0 && <TableRow><TableCell colSpan={6} className="text-center text-slate-500 py-10">Nessun log.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </CardContent></Card>
    </div>
  );
}
